<template>
  <div class="view">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>
      {{ titleinfo }}
    </div>
    <div class="content whd-bgwhite whd-video">
      <el-form ref="form" :model="formdata" label-width="120px">
        <el-form-item class="is-required" label="相册分类" prop="cat_id">
          <el-select
            v-model="formdata.cat_id"
            placeholder="请选择"
            @change="change"
          >
            <el-option
              v-for="item in albumClassification"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="is-required" label="相册名称" prop="title">
          <el-input
            class="whd-w360"
            v-model="formdata.title"
            type="text"
            maxlength="20"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="相册排序" prop="sort">
          <el-input
            class="w160"
            v-model="formdata.sort"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="is-required whd-form-item"
          label="封面图展示"
          prop="cover_img"
        >
          <div class="addicon">
            <div
              class="el-upload el-upload--text"
              @click="corppervisible = true"
            >
              <ul v-if="formdata.cover_img" class="perview_img">
                <li><img :src="formdata.cover_img" /></li>
              </ul>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </div>
            <div class="el-upload__tip">
              可选填，图片建议尺寸336*336，支付JPG、PNG格式
            </div>
          </div>
        </el-form-item>
        <el-form-item
          class="is-required whd-form-item"
          label="相册内容"
          prop="imgs"
        >
          <uploadAlbumDrag
            v-if="formdata.imgs"
            :picture="formdata.imgs"
            @uploadsucess="uploaddetail"
            @onSetCoverImg="onSetCoverImg"
            ref="pictures"
          >
          </uploadAlbumDrag>
          <div class="el-upload__tip" style="margin-top: 0">
            长按拖动图片顺序
          </div>
        </el-form-item>
        <el-form-item>
          <el-button @click="btnSave(0)">仅保存</el-button>
          <el-button type="primary" @click="btnSave(1)">保存并发布</el-button>
        </el-form-item>
      </el-form>
    </div>
    <corpper
      :visible.sync="corppervisible"
      v-if="corppervisible"
      @imgAddBack="imgAddBack"
      :imgSize="15"
    ></corpper>
  </div>
</template>

<script>
import api from "@/api.js";
import corpper from "@/components/dialog/corpper.vue";
import uploadAlbumDrag from "@/components/uploadAlbumDrag.vue";
export default {
  name: "addOrEditAlbum",
  components: {
    corpper,
    uploadAlbumDrag,
  },
  data() {
    return {
      corppervisible: false,
      titleinfo: "",
      uploadImg: api.uploadTokenImg,
      uploadvideourl: api.uploadTokenVideo,
      data_: { token: sessionStorage.getItem("token") },
      formdata: {
        id: "",
        cat_id: "",
        title: "",
        cover_img: "",
        imgs: [],
        release: "",
        sort: "",
      },
      imgs: [],
      albumClassification: [],
      page: {
        pageindex: 1,
        pagesize: 999,
        // total: 20,
      },
    };
  },
  created() {
    this.querylist();
    if (this.$route.query.id) {
      this.formdata.id = this.$route.query.id;
      this.titleinfo = "编辑相册";
      this.InitFn();
    } else {
      this.titleinfo = "添加相册";
    }
  },
  methods: {
    change(e) {
      console.log(e, 12345678);
    },
    //查询列表
    querylist() {
      let params = {
        page: this.page.pageindex,
      };
      this.axios
        .post(api.album_cate, params)
        .then((response) => {
          if (response.data.code == 0) {
            this.albumClassification = response.data.list;
            this.page.total = response.data.all_page;
          } else {
            this.page.total = 0;
          }
        })
        .catch(() => {});
    },
    goback() {
      this.$router.go(-1);
    },
    imgAddBack(option) {
      this.formdata.cover_img = option;
    },
    uploaddetail(val) {
      this.imgs = val;
    },
    onSetCoverImg(option) {
      this.formdata.cover_img = option;
    },
    // 保存
    btnSave(option) {
      let formdata = {
        id: this.formdata.id,
        cat_id: this.formdata.cat_id,
        title: this.formdata.title,
        cover_img: this.formdata.cover_img,
        sort: parseInt(this.formdata.sort),
        release: option,

        imgs: [],
      };
      if (!this.formdata.title) {
        this.$message.warning("请填写相册名称");
        return;
      }
      if (!this.formdata.cover_img) {
        this.$message.warning("请设置封面图");
        return;
      }
      if (this.imgs.length == 0) {
        this.$message.warning("请上传相册内容");
        return;
      } else {
        const arr = [];
        this.imgs.forEach((item, i) => {
          formdata.imgs.push({ img: item.img, name: item.name });
        });
      }
      this.axios
        .post(api.album_save, formdata)
        .then((response) => {
          if (response.data.code == 0) {
            this.$message.success("保存成功");
          }
        })
        .catch(() => {});
    },
    InitFn() {
      this.axios
        .post(api.album_detail, { id: this.formdata.id })
        .then((response) => {
          if (response.data.code == 0) {
            const imgs = response.data.result.imgs;
            this.imgs = imgs;
            this.formdata = response.data.result;
            this.formdata.cat_id = this.formdata.cat_id * 1;
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.addicon .avatar-uploader-icon {
  width: 148px;
  height: 148px;
  line-height: 148px;
}
</style>
